export default __webpack_public_path__ + "static/media/videoImage.0f137e10.png";